import { render, staticRenderFns } from "./feelings.vue?vue&type=template&id=26f6283f&scoped=true"
import script from "./feelings.vue?vue&type=script&lang=js"
export * from "./feelings.vue?vue&type=script&lang=js"
import style0 from "./feelings.vue?vue&type=style&index=0&id=26f6283f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f6283f",
  null
  
)

export default component.exports